import Vue from 'vue'
import nodeUtils from '@/builder/NodeUtils'
import componentBuilder from '@/builder/ComponentBuilder'
import utils from '@/builder/utils'
import clientApiFunctions from './ClientApiFunctions'
import formState from './FormState'
import pwautils from './PWAUtils'
import events from './Events'
// import tracking from './Tracking'
import webResources from './WebResources'
import pageNavigator from '@/api/PageNavigator'
import browserbuttonNavigator from '@/api/BrowserbuttonNavigator'
import elementValidator from '@/api/ElementValidator'
import httpFetch from '@/api/HTTPFetch'
import httpBase from '@/api/HTTPBase'
import Validations from '@/api/ElementValidations'
import fingerPrinting from '@/builder/FingerPrinting'

// import _ from 'lodash'

/**
 * Esta es la API que pueden usar los desarrolladores de formularios.
 * Se usa en runtime para usar los componentes que existan.
 */
let api = {
    setSchema: (s) => {
        api.schema = s
        events.setClientAPI(api)
        nodeUtils.setClientAPI(api)
        componentBuilder.setClientAPI(api)
        pageNavigator.setClientAPI(api)
        browserbuttonNavigator.setClientAPI(api)
        formState.setClientAPI(api)
        elementValidator.setClientAPI(api)
        webResources.setClientAPI(api)
        httpFetch.setClientAPI(api)
        // tracking.setClientAPI(api)

        componentBuilder.renderSchema(api.schema)

        // ojito con usar esto. Recrea el arbol del formulario y borra el contenido
        // de los input type=file. Usar solamente cuando sea estrictamente necesario.
        nodeUtils.forceUpdate()
    },

    getSchema: () => api.schema,

    ...clientApiFunctions,
    ...pageNavigator,
    ...formState,
    ...nodeUtils,
    ...webResources,
    ...httpFetch,
    ...httpBase,
    validators: Validations,
    events: events.events,
    eventSubscribe: events.eventSubscribe,
    eventPublish: events.eventPublish,
    clearSubscriptions: events.clearSubscriptions,

    /*
    // por borrar
    raiseEvent: events.raiseEvent,
    listenEvent: events.listenEvent,
    addEventListenerOnce: events.addEventListenerOnce,
    */

    validateElem: elementValidator.validateElem,
    isRequired: elementValidator.isRequired,
    hasErrors: elementValidator.hasErrors,
    clearValidationErrors: elementValidator.clearValidationErrors,
    getHTMLInputFileContent: utils.getHTMLInputFileContent,
    eval: utils.evalExpression,
    evalExpression: utils.evalExpression,
    evalObject: utils.evalObject,
    getFilename: utils.getFilename,
    generateUUID: utils.generateUUID,
    hash: utils.hash,
    toClipboard: (t) => {   navigator.clipboard.writeText(t); },
    addPlugin: (plugin) => {
        api.plugins = api.plugins || {}
        let desc = plugin.describe()
        window.console.log('Registrando plugin ', desc.description || 'Sin nombre');

        api.plugins[desc.name] = plugin
    },
    canInstalAsPWA: pwautils.canInstalAsPWA,
    showInstallPrompt: pwautils.showInstallPrompt,
    webPushIsSupported: pwautils.webPushIsSupported,
    webPushRequestPermission: pwautils.webPushRequestPermission,
    webPushServerSubscribe: pwautils.webPushServerSubscribe,
    getFormIDFromURL: httpBase.getFormIDFromURL,
    getDeviceUUID: fingerPrinting.getDeviceUUID,
    navigateToForm: (formID) => {
        const event = new CustomEvent('navigateToForm', { detail: formID });
        document.dispatchEvent(event);
    },
    scrollTo: events.scrollTo,
    reactiveUpdate: (component, target, newVal) => {
        let k = {}

        if (Array.isArray(newVal)) {
            k = Array.apply(null, newVal);
        } else if (typeof newVal === 'object') {
            Object.assign(k, component[target], newVal)
        } else {
            k = newVal
        }

        Vue.set(component, target, k)
    }
}


window.console.log(`Inicializando ...

███████████  ████████                   ███████████
░░███░░░░░░█ ███░░░░███                 ░░███░░░░░░█
 ░███   █ ░ ░░░    ░███                  ░███   █ ░   ██████  ████████  █████████████    █████
 ░███████      ███████     ██████████    ░███████    ███░░███░░███░░███░░███░░███░░███  ███░░
 ░███░░░█     ███░░░░     ░░░░░░░░░░     ░███░░░█   ░███ ░███ ░███ ░░░  ░███ ░███ ░███ ░░█████
 ░███  ░     ███      █                  ░███  ░    ░███ ░███ ░███      ░███ ░███ ░███  ░░░░███
 █████      ░██████████                  █████      ░░██████  █████     █████░███ █████ ██████
░░░░░       ░░░░░░░░░░                  ░░░░░        ░░░░░░  ░░░░░     ░░░░░ ░░░ ░░░░░ ░░░░░░


                                                                                               `)
export default api